import { CONFIG } from 'config/config';

import { isMobile } from 'react-device-detect';
import styled from 'styled-components/macro';

export const SmallButton = styled.button`
	cursor: pointer;
	font-size: 18px;
	font-weight: 800;
	min-width: ${isMobile ? '100%' : '225px'};
	margin: ${isMobile ? '10px 0px' : '10px'};
	color: ${(props) => {
		return props?.style?.textColor ?? CONFIG.colors.white;
	}};
	text-align: center;
	padding: ${isMobile ? '7px 10px' : '10px 10px'};
	border-radius: 3px;
	outline: none;
	border: ${(props) => {
		return `2px solid ${props?.style?.borderColor ?? CONFIG.colors.primary}`;
	}};
	background-color: ${(props) => {
		return props?.style?.backgroundColor ?? CONFIG.colors.primary;
	}};

	:disabled {
		opacity: 0.5;
		cursor: default;
	}

	:hover {
		${(props) => {
		if (!props?.style?.disabled) {
			return `color: ${CONFIG.colors.primary} !important;
					background-color: ${CONFIG.colors.white} !important;
					border-color: ${CONFIG.colors.primary} !important;
					`
		}
	}}
	};
`;
